module.exports = __webpack_public_path__ + "media/images/svg/chevron-down-2b075f3dea6f9cf176355aed13b139eb.svg";